import React, { useEffect, useRef, useState } from "react";
import { Box, Text } from "@primer/react";
import {
  ChevronRightIcon,
} from "@primer/octicons-react";
import { phuHuynhApi } from "../../api/phuHuynhApi";
import UserAvatar from "../user-avatar";

interface PhuHuynhFamilyMember {
  id: string | number;
  ho_ten: string;
  quan_he: string;
  email: string;
  dien_thoai: string;
}

interface PhuHuynhFamilyProps {
  id: number;
  onMemberSelect?: (memberId: number) => void;
}

const PhuHuynhFamily: React.FC<PhuHuynhFamilyProps> = ({
  id,
  onMemberSelect,
}) => {
  const [phuHuynhFamilys, setPhuHuynhFamily] = useState<PhuHuynhFamilyMember[]>(
    []
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const componentDidMount = useRef<boolean>(false);

  useEffect(() => {
    componentDidMount.current = true;
    handleReloadPhuHuynhFamily();
    return () => {
      componentDidMount.current = false;
    };
  }, [id]);

  const handleReloadPhuHuynhFamily = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const res = await phuHuynhApi.selectFamily(id);
      if (componentDidMount.current) {
        setIsLoading(false);
        if (res.is_success) {
          setPhuHuynhFamily(res.data);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error loading family data:", error);
    }
  };

  if (isLoading || phuHuynhFamilys.length === 0) return null;

  return (
    <Box>
      <Text as="div" sx={{ fontSize: 0, fontWeight: 600, color: "fg.muted", textTransform: "uppercase", letterSpacing: "0.3px", mb: 1, px: 2 }}>
        {`Thành viên khác (${phuHuynhFamilys.length})`}
      </Text>
      {phuHuynhFamilys.map((member, index) => (
        <Box
          key={index}
          title={member.email || undefined}
          onClick={() => onMemberSelect?.(Number(member.id))}
          sx={{
            display: "flex", alignItems: "center", gap: 2, px: 2, py: 2,
            borderRadius: 2, cursor: "pointer",
            "&:hover": { bg: "canvas.subtle" },
            "&:hover .chevron": { visibility: "visible" },
          }}
        >
          <UserAvatar fullName={member.ho_ten} size="large" />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Text as="div" sx={{ fontWeight: 600, fontSize: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {member.ho_ten}
            </Text>
            <Text as="div" sx={{ fontSize: 0, color: "fg.muted", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {[member.quan_he, member.dien_thoai].filter(Boolean).join(" · ")}
            </Text>
          </Box>
          <Box className="chevron" sx={{ color: "fg.muted", visibility: "hidden", display: "flex" }}>
            <ChevronRightIcon size={16} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default PhuHuynhFamily;
